import { render, staticRenderFns } from "./CopMaterialEdit.vue?vue&type=template&id=127f3e61&scoped=true"
import script from "./CopMaterialEdit.vue?vue&type=script&lang=js"
export * from "./CopMaterialEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f3e61",
  null
  
)

export default component.exports